import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { workingSteps } from '../mock';

const WorkingSteps = () => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <section id="process" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">Working Steps</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-4">
            Your Roadmap to Building the <span className="text-orange-600">Home of Your Dreams</span>
          </h2>
        </div>

        {/* Steps Navigation */}
        <div className="flex flex-wrap justify-center gap-4 mb-16">
          {workingSteps.map((step, index) => (
            <button
              key={index}
              onClick={() => setActiveStep(index)}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                activeStep === index
                  ? 'bg-orange-600 text-white shadow-lg scale-105'
                  : 'bg-slate-100 text-gray-700 hover:bg-slate-200'
              }`}
            >
              <span className="text-sm">{step.step}</span>
              <span className="ml-2">{step.title}</span>
            </button>
          ))}
        </div>

        {/* Active Step Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img
              src={workingSteps[activeStep].image}
              alt={workingSteps[activeStep].title}
              className="w-full h-[500px] object-cover"
            />
            <div className="absolute top-8 left-8 bg-white rounded-2xl shadow-xl p-4">
              <p className="text-5xl font-bold text-orange-600">{workingSteps[activeStep].step}</p>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <div>
              <h3 className="text-4xl font-bold text-gray-900 mb-4">{workingSteps[activeStep].title}</h3>
              <p className="text-lg text-gray-600 leading-relaxed">{workingSteps[activeStep].description}</p>
            </div>

            <ul className="space-y-3">
              {workingSteps[activeStep].points.map((point, idx) => (
                <li key={idx} className="flex items-start space-x-3">
                  <ChevronRight className="w-5 h-5 text-orange-600 mt-1 flex-shrink-0" />
                  <span className="text-gray-700 font-medium">{point}</span>
                </li>
              ))}
            </ul>

            {/* Navigation Buttons */}
            <div className="flex gap-4 pt-6">
              <button
                onClick={() => setActiveStep((prev) => (prev > 0 ? prev - 1 : workingSteps.length - 1))}
                className="px-6 py-3 border-2 border-gray-300 rounded-lg text-gray-700 font-semibold hover:border-orange-600 hover:text-orange-600 transition-colors"
              >
                Previous Step
              </button>
              <button
                onClick={() => setActiveStep((prev) => (prev < workingSteps.length - 1 ? prev + 1 : 0))}
                className="px-6 py-3 bg-orange-600 text-white rounded-lg font-semibold hover:bg-orange-700 transition-colors"
              >
                Next Step
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkingSteps;